import { Router, RouterLink } from '@angular/router';
import { Subscription } from 'rxjs';
import { Component, computed, OnDestroy, OnInit, signal, WritableSignal, inject } from '@angular/core';
import { HeaderPattern } from "../../../shared/utils/header-list";
import { IHeaderLinks } from "../../../shared/interfaces/IHeaderLinks";
import { RolesEnum, RoutesEnum } from "../../../shared/utils/RoutesEnum";
import { HeaderService } from "../../../shared/services/header.service";
import { AuthService } from "../../../shared/services/auth.service";
import { headerList } from "../../../configuration/headerList";
import config from './../../../configuration/config.json';
import { NgClass } from '@angular/common';
import { TooltipDirective } from 'ngx-bootstrap/tooltip';
import { NzDropdownDirective, NzDropdownMenuComponent } from 'ng-zorro-antd/dropdown';
import { NzIconDirective } from 'ng-zorro-antd/icon';
import { NzMenuDirective, NzMenuItemComponent } from 'ng-zorro-antd/menu';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'dynamica-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [
    RouterLink,
    NgClass,
    TooltipDirective,
    NzDropdownDirective,
    NzIconDirective,
    NzDropdownMenuComponent,
    NzMenuDirective,
    NzMenuItemComponent,
    TranslatePipe,
  ],
})
export class HeaderComponent implements OnInit, OnDestroy {
  
  private headerService = inject(HeaderService);
  private router = inject(Router);
  private authService = inject(AuthService);

  headerItem: HeaderPattern;
  moduleHeaderItem$: Subscription;
  activatedTab: number;
  headerLinks: IHeaderLinks[] = [];
  configuration: WritableSignal<typeof config> = signal(config);
  isClusterPricingAvailable = computed(
    () => this.configuration().clusterPricing.enabled && this.authService.roles.includes(RolesEnum.AdminRole),
  );
  isAdminSettingsAvailable = computed(
    () =>
      this.configuration().adminSettings.enabled && this.authService.roles.includes(RolesEnum.SuperAdminRole),
  );
  isstrategyPriceOverrideAvailable = computed(
    () =>
      this.configuration().strategyPriceOverride.enabled &&
      this.authService.roles.includes(RolesEnum.AdminRole),
  );
  protected readonly RoutesEnum = RoutesEnum;

  ngOnInit(): void {
    this.moduleHeaderItem$ = this.headerService.moduleHeaderItem.subscribe((res: any) => {
      if (res?.tabs) {
        this.headerItem = res;
        this.activatedTab = res.tabs.findIndex((tab) => tab.active);
      }
    });

    this.headerLinks = headerList.map((item) => {
      const newItem = {
        ...item,
        path: item.path,
        title: item.title,
        icon: item.icon,
        subMenu: null,
        hasRole: item.role.some((ele) => this.authService.getRoles().includes(ele)) && item.isEnabled,
      };
      return newItem;
    });
  }

  navigatePathUrl(module: string, tabs: string, subTabs?: string): void {
    const path = subTabs ? module + '/' + tabs + '/' + subTabs : module + '/' + tabs;
    this.router.navigate([path]);
  }

  logout(): void {
    this.authService.logout();
  }

  ngOnDestroy(): void {
    this.moduleHeaderItem$?.unsubscribe();
  }
}
